import { render } from "./HomeObjectivesView.vue?vue&type=template&id=0d7d023d&scoped=true"
import script from "./HomeObjectivesView.vue?vue&type=script&lang=js"
export * from "./HomeObjectivesView.vue?vue&type=script&lang=js"

import "./HomeObjectivesView.vue?vue&type=style&index=0&id=0d7d023d&scoped=true&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7d023d"]])

export default __exports__